"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _OoxmlContent = _interopRequireDefault(require("@common/components/remedy/OoxmlContent"));
var _useClampedOverflow2 = require("@common/hooks/use-clamped-overflow");
var _button = require("@design/ui/button");
var _card = require("@design/ui/card");
var _collapsible = require("@design/ui/collapsible");
var _utils = require("@design/lib/utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function RedlinePreview(_ref) {
  var ooxml = _ref.ooxml,
    driftWarning = _ref.driftWarning,
    stepNavigation = _ref.stepNavigation,
    actions = _ref.actions,
    containerStyle = _ref.containerStyle,
    revisionTitle = _ref.revisionTitle,
    _ref$drawMoveMarks = _ref.drawMoveMarks,
    drawMoveMarks = _ref$drawMoveMarks === void 0 ? false : _ref$drawMoveMarks,
    _ref$drawReplacementG = _ref.drawReplacementGaps,
    drawReplacementGaps = _ref$drawReplacementG === void 0 ? false : _ref$drawReplacementG;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSelecting = _useState4[0],
    setIsSelecting = _useState4[1];
  var mouseDownRef = (0, _react.useRef)(false);
  var _useClampedOverflow = (0, _useClampedOverflow2.useClampedOverflow)(ooxml, isExpanded),
    clampedRef = _useClampedOverflow.clampedRef,
    canExpand = _useClampedOverflow.canExpand;
  function handlePreviewClick(e) {
    var _window$getSelection$, _window$getSelection;
    if (!canExpand) return;
    var target = e.currentTarget;
    var rect = target.getBoundingClientRect();
    var scrollbarWidth = target.offsetWidth - target.clientWidth;
    var clickedOnScrollbar = e.clientX > rect.right - scrollbarWidth;
    var selectedText = (_window$getSelection$ = (_window$getSelection = window.getSelection()) === null || _window$getSelection === void 0 ? void 0 : _window$getSelection.toString()) !== null && _window$getSelection$ !== void 0 ? _window$getSelection$ : "";
    var hasSelection = selectedText.length > 0;
    if (!clickedOnScrollbar && !hasSelection && !isSelecting) {
      setIsExpanded(!isExpanded);
    }
    setIsSelecting(false);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [driftWarning, /*#__PURE__*/(0, _jsxRuntime.jsx)(_collapsible.Collapsible, {
      open: isExpanded,
      onOpenChange: setIsExpanded,
      asChild: true,
      "data-sentry-element": "Collapsible",
      "data-sentry-source-file": "RedlinePreview.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.Card, {
        size: "sm",
        style: containerStyle,
        className: "w-full self-stretch",
        "data-sentry-element": "Card",
        "data-sentry-source-file": "RedlinePreview.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_card.CardContent, {
          "data-sentry-element": "CardContent",
          "data-sentry-source-file": "RedlinePreview.tsx",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            ref: clampedRef,
            onMouseDown: function onMouseDown() {
              mouseDownRef.current = true;
              setIsSelecting(false);
            },
            onMouseUp: function onMouseUp() {
              mouseDownRef.current = false;
            },
            onMouseMove: function onMouseMove() {
              if (mouseDownRef.current) setIsSelecting(true);
            },
            onClick: handlePreviewClick,
            className: (0, _utils.cn)(canExpand && "cursor-pointer", isExpanded ? "max-h-[calc(100vh-280px)] overflow-auto" : "max-h-[4lh] overflow-hidden"),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OoxmlContent.default, {
              ooxml: ooxml,
              getHtmlTitleProp: revisionTitle,
              drawMoveMarks: drawMoveMarks,
              drawReplacementGaps: drawReplacementGaps,
              "data-sentry-element": "OoxmlComponent",
              "data-sentry-source-file": "RedlinePreview.tsx"
            })
          })
        }), (canExpand || stepNavigation || actions) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.CardFooter, {
          className: "flex-wrap gap-2",
          children: [canExpand && /*#__PURE__*/(0, _jsxRuntime.jsx)(_collapsible.CollapsibleTrigger, {
            asChild: true,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
              type: "button",
              variant: "link",
              size: "xs",
              children: isExpanded ? "Show less" : "Show more"
            })
          }), stepNavigation, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "ml-auto flex items-center gap-2",
            children: actions
          })]
        })]
      })
    })]
  });
}
var _default = exports.default = RedlinePreview;